/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {
	NbDatepickerModule,
	NbDialogModule,
	NbMenuModule,
	NbSidebarModule,
	NbToastrModule,
	NbWindowModule,
} from '@nebular/theme';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {AuthGuard} from './auth/services/auth-guard.service';
import {Globals} from './globals';
import {APP_BASE_HREF} from '@angular/common';
import {NbAuthJWTInterceptor} from './auth/services/interceptors/jwt-interceptor';
import {NbSecurityModule} from './security/security.module';
import {BASE_PATH} from './@core/apis';
import {environment} from '../environments/environment';
import {NbDateFnsDateModule} from '@nebular/date-fns';
import {NbApiRoleProvider} from './security/services/api-role.provider';
import {NbRoleProvider} from './security/services/role.provider';
import {NgSelectModule} from '@ng-select/ng-select';
import {PermissionService} from './security/services/permission.service';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http);
}

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		HttpClientModule,
		AppRoutingModule,
		NgSelectModule,
		NbSidebarModule.forRoot(),
		NbMenuModule.forRoot(),
		NbDatepickerModule.forRoot(),
		NbDialogModule.forRoot(),
		NbWindowModule.forRoot(),
		NbToastrModule.forRoot(),
		CoreModule.forRoot(),
		ThemeModule.forRoot(),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		NbDateFnsDateModule.forRoot({
			parseOptions: {awareOfUnicodeTokens: true},
			format: 'dd/MM/yyyy',
			formatOptions: {awareOfUnicodeTokens: true},
		}),
	],
	bootstrap: [AppComponent],
	providers: [
		{provide: APP_BASE_HREF, useValue: '/'},
		{provide: BASE_PATH, useValue: environment.apiBaseEndpoint + environment.appName},
		{provide: HTTP_INTERCEPTORS, useClass: NbAuthJWTInterceptor, multi: true},
		NbSecurityModule.forRoot({
			accessControl: {},
		}).providers,
		{provide: NbRoleProvider, useClass: NbApiRoleProvider},
		PermissionService,
		AuthGuard,
		Globals,
	],
})
export class AppModule {
}
